import { useEffect, useRef } from "react"
import propTypes from "prop-types"
import { useReactToPrint } from "react-to-print"

import CashCutTicket from "./CashCutTicket"

const CashCutTicketPrinter = ({ item, businessInfo, autoPrint, onAfterPrint }) => {
  const componentRef = useRef(null)

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    onAfterPrint,
  })

  useEffect(() => {
    if (autoPrint && item) {
      handlePrint()
    }
  }, [autoPrint, item, handlePrint])

  if (!item) {
    return null
  }

  return (
    <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
      <CashCutTicket ref={componentRef} item={item} businessInfo={businessInfo} />
    </div>
  )
}

CashCutTicketPrinter.propTypes = {
  item: propTypes.object,
  businessInfo: propTypes.object,
  autoPrint: propTypes.bool,
  onAfterPrint: propTypes.func,
}

export default CashCutTicketPrinter
